<script lang="ts" setup>
const props = withDefaults(
    defineProps<{
        small?: boolean;
        condensed?: boolean;
        grid?: string;
        cols?: string;
        padding?: true | string;
        gap?: string;
        leftSpan?: string;
        rightSpan?: string;
        placement?: "start" | "center";
        itemPadding?: string;
        clickable?: boolean;
    }>(),
    {
        small: false,
        placement: "center",
        padding: true,
        grid: undefined,
        gap: undefined,
        cols: undefined,
        leftSpan: undefined,
        rightSpan: undefined,
        itemPadding: undefined,
        clickable: false,
    },
);

const emit = defineEmits<{
    click: [event: MouseEvent];
}>();

function handleClick(event: MouseEvent) {
    if (props.clickable) {
        emit("click", event);
    }
}
</script>

<template>
    <div
        :class="[
            'ui-data-list-item',
            gap ?? (small ? '@xs:gap-4 @xs:px-0' : '@sm:gap-4 @sm:px-0'),
            grid ?? (small ? '@xs:grid' : '@sm:grid'),
            condensed ? (itemPadding ?? 'py-3') : (itemPadding ?? 'px-4 py-6'),
            cols ?? (small ? '@xs:grid-cols-3' : '@sm:grid-cols-3'),
            clickable
                ? 'cursor-pointer hover:bg-gray-50 transition-colors'
                : '',
        ]"
        @click="handleClick"
    >
        <dt
            v-if="$slots.label"
            :class="[
                placement === 'start' ? 'items-start' : 'items-center',
                !$slots.value ? 'col-span-full' : leftSpan,
                padding === true ? 'px-4' : (padding ?? ''),
            ]"
            class="min-w-0 text-sm flex font-medium leading-6 text-gray-900"
        >
            <slot name="label" />
        </dt>
        <dd
            v-if="$slots.value"
            :class="[
                placement === 'start' ? 'items-start' : 'items-center',
                !$slots.label
                    ? 'col-span-full'
                    : (rightSpan ??
                      (small ? '@xs:col-span-2' : '@sm:col-span-2')),
                padding === true ? 'px-4' : (padding ?? ''),
            ]"
            class="min-w-0 text-sm flex leading-6 text-gray-700 @sm:mt-0"
        >
            <slot name="value" />
        </dd>
        <slot />
    </div>
</template>
